var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner__container"},[_c('div',{staticClass:"loading-spinner"},[_c('LoadingSpinner',{staticClass:"loading-spinner__spinner"})],1),_c('h3',{staticClass:"loading-spinner__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }